import { MachineGroupScheduleTimeRange } from './machine-group-schedule-time-range';

export class MachineGroupCalendarDay {
  constructor(
    public date: number,
    public timeRange?: MachineGroupScheduleTimeRange[],
    public colors?: string[],
    public edited?: boolean,
  ) { }

  clone() {
    return new MachineGroupCalendarDay(
      this.date,
      this.timeRange,
      this.colors,
      this.edited
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/calendar/machine-group-calendar-day.ts